import { WebSocketActions } from "./actions";

export const WS = {
    CONNECT: "ws.connect",
    DISCONNECT: "ws.disconnect",
};

//Keep this in synch with io.truweb.combined.events.socket.model.UIEventType on the backend
export const EventType = {
    PRE_LOAN_EXPIRED: "PRE_LOAN_EXPIRED",
    OFFER_EXPIRED: "OFFER_EXPIRED",
    TX_UNCONFIRMED: "TX_UNCONFIRMED",
    LOAN_REQUEST_SEND_FAILED: "LOAN_REQUEST_SEND_FAILED",
    OFFER_SEND_FAILED: "OFFER_SEND_FAILED",
    PRELOAN_SEND_FAILED: "PRELOAN_SEND_FAILED",

    REJECT_SEND_FAILED: "REJECT_SEND_FAILED",
    CONFIRM_SEND_FAILED: "CONFIRM_SEND_FAILED",
    ERROR_OFFER_EXPIRED: "ERROR_OFFER_EXPIRED",
    // it's also raised when unable to acquire lock,
    // perhaps a separate error would be better
    ERROR_TX_ILLEGAL_STATUS: "ERROR_TX_ILLEGAL_STATUS",
    ERROR_TX_ILLEGAL_OFFER: "ERROR_TX_ILLEGAL_OFFER",
    ERROR_TX_ILLEGAL_LOAN: "ERROR_TX_ILLEGAL_LOAN",
    ERROR_TX_ILLEGAL_REJECT: "ERROR_TX_ILLEGAL_REJECT",
    ERROR_TX_ILLEGAL_FORK: "ERROR_TX_ILLEGAL_FORK",
    ERROR_TX_ILLEGAL_RELEASE: "ERROR_TX_ILLEGAL_RELEASE",
    ERROR_TX_ILLEGAL_UPGRADE: "ERROR_TX_ILLEGAL_UPGRADE",

    CONFIRMATION_CREATED: "CONFIRMATION_CREATED",

    CONFIRM_SENT: "CONFIRM_SENT",
    CONFIRMATION_MODIFIED: "CONFIRMATION_MODIFIED",
    CONFIRMATION_RECEIVED: "CONFIRMATION_RECEIVED",
    FILES_STORED: "FILES_STORED",

    INVENTORY_BATCH_ADDED: "INVENTORY_BATCH_ADDED",
    INVENTORY_BATCH_DELETED: "INVENTORY_BATCH_DELETED",
    INVENTORY_BATCH_UPDATED: "INVENTORY_BATCH_UPDATED",

    UNKNOWN_ERROR: "UNKNOWN_ERROR",

    PRELOAN_BATCH_CREATED: "PRELOAN_BATCH_CREATED",
    LOAN_REQUEST_BATCH_CREATED: "LOAN_REQUEST_BATCH_CREATED",
    OFFER_BATCH_CREATED: "OFFER_BATCH_CREATED",
    REJECT_BATCH_CREATED: "REJECT_BATCH_CREATED",
    PRELOAN_BATCH_RECEIVED: "PRELOAN_BATCH_RECEIVED",
    OFFER_BATCH_RECEIVED: "OFFER_BATCH_RECEIVED",
    LOAN_REQUEST_BATCH_RECEIVED: "LOAN_REQUEST_BATCH_RECEIVED",
    REJECT_BATCH_RECEIVED: "REJECT_BATCH_RECEIVED",
    TX_BATCH_CONFIRMED: "TX_BATCH_CONFIRMED",
    TX_FORK_BATCH_CREATED: "TX_FORK_BATCH_CREATED",
    TX_FORK_BATCH_RECEIVED: "TX_FORK_BATCH_RECEIVED",
    TX_BATCH_RELEASED: "TX_BATCH_RELEASED",
    TX_RELEASE_BATCH_RECEIVED: "TX_RELEASE_BATCH_RECEIVED",
    TX_BATCH_UPGRADE_REQUESTED: "TX_BATCH_UPGRADE_REQUESTED",
    TX_BATCH_UPGRADED: "TX_BATCH_UPGRADED",
    TX_UPGRADE_BATCH_RECEIVED: "TX_UPGRADE_BATCH_RECEIVED",
    TX_UPGRADE_REQUEST_BATCH_RECEIVED: "TX_UPGRADE_REQUEST_BATCH_RECEIVED",

    PRE_LOAN_BATCH_SENT: "PRE_LOAN_BATCH_SENT",
    PRE_LOAN_BATCH_UPDATED: "PRE_LOAN_BATCH_UPDATED",
    UNSOLICITED_OFFER_BATCH_MATCHED: "UNSOLICITED_OFFER_BATCH_MATCHED",
    PRE_LOAN_BATCH_UPDATE_RECEIVED: "PRE_LOAN_BATCH_UPDATE_RECEIVED",
    OFFER_BATCH_SENT: "OFFER_BATCH_SENT",
    LOAN_REQUEST_BATCH_SENT: "LOAN_REQUEST_BATCH_SENT",
    TX_CONFIRM_BATCH_SENT: "TX_CONFIRM_BATCH_SENT",
    TX_CONFIRM_BATCH_RECEIVED: "TX_CONFIRM_BATCH_RECEIVED",
    TX_FORK_BATCH_SENT: "TX_FORK_BATCH_SENT",
    TX_RELEASE_BATCH_SENT: "TX_RELEASE_BATCH_SENT",
    TX_UPGRADE_BATCH_SENT: "TX_UPGRADE_BATCH_SENT",
    REJECT_BATCH_SENT: "REJECT_BATCH_SENT",
    TX_BATCH_MODIFIED: "TX_BATCH_MODIFIED",
    TX_BATCH_CANCELED: "TX_BATCH_CANCELED",
    TX_MODIFY_BATCH_RECEIVED: "TX_MODIFY_BATCH_RECEIVED",
    TX_CANCEL_BATCH_RECEIVED: "TX_CANCEL_BATCH_RECEIVED",
    WITHDRAWAL_BATCH_SENT: "WITHDRAWAL_BATCH_SENT",
    WITHDRAWAL_BATCH_RECEIVED: "WITHDRAWAL_BATCH_RECEIVED",

    CONFIRM_PROJECTION_UPDATED: "CONFIRM_PROJECTION_UPDATED",
    CONFIRM_PROJECTION_INSERTED: "CONFIRM_PROJECTION_INSERTED",

    //Availability events
    AVAILABILITY_BATCH_DELETED: "AVAILABILITY_BATCH_DELETED",
    AVAILABILITY_BATCH_RECEIVED: "AVAILABILITY_BATCH_RECEIVED",

    //settings
    CPTY_SETTINGS_UPDATED: "CPTY_SETTINGS_UPDATED",
    CPTY_BORROWER_LIST_SETTINGS_UPDATED: "CPTY_BORROWER_LIST_SETTINGS_UPDATED",

    //Recall events
    RECALL_BATCH_CREATED: "RECALL_BATCH_CREATED",
    RECALL_BATCH_SENT: "RECALL_BATCH_SENT",
    RECALL_BATCH_RECEIVED: "RECALL_BATCH_RECEIVED",
    RECALL_BATCH_DISPUTED: "RECALL_BATCH_DISPUTED",
    RECALL_BATCH_DISPUTED_RECEIVED: "RECALL_BATCH_DISPUTED_RECEIVED",
    RECALL_BATCH_CANCELED: "RECALL_BATCH_CANCELED",
    RECALL_BATCH_CANCELED_RECEIVED: "RECALL_BATCH_CANCELED_RECEIVED",

    // Client Pool
    CLIENT_POOL_UPDATED: "CLIENT_POOL_UPDATED",

    // Trade activity
    TRADE_ACTIVITY_UPDATED: "TRADE_ACTIVITY_UPDATED",
};

export const illegalMessageByType = (type) => {
    switch (type) {
        case EventType.ERROR_TX_ILLEGAL_OFFER:
            return "Could not perform offer";
        case EventType.ERROR_TX_ILLEGAL_LOAN:
            return "Could not create loan";
        case EventType.ERROR_TX_ILLEGAL_REJECT:
            return "Could not perform reject";
        case EventType.ERROR_TX_ILLEGAL_FORK:
            return "Could not perform fork";
        case EventType.ERROR_TX_ILLEGAL_RELEASE:
            return "Could not perform release";
        case EventType.ERROR_TX_ILLEGAL_UPGRADE:
            return "Could not perform upgrade";
        default:
            return null;
    }
};

export const batch_types = [
    EventType.PRELOAN_BATCH_CREATED,
    EventType.PRELOAN_BATCH_RECEIVED,
    EventType.PRE_LOAN_BATCH_UPDATED,
    EventType.PRE_LOAN_BATCH_UPDATE_RECEIVED,
    EventType.LOAN_REQUEST_BATCH_CREATED,
    EventType.LOAN_REQUEST_BATCH_RECEIVED,
    EventType.OFFER_BATCH_CREATED,
    EventType.OFFER_BATCH_RECEIVED,
    EventType.TX_BATCH_CONFIRMED,
    EventType.TX_CONFIRM_BATCH_SENT,
    EventType.TX_CONFIRM_BATCH_RECEIVED,
    EventType.TX_FORK_BATCH_CREATED,
    EventType.TX_FORK_BATCH_RECEIVED,
    EventType.INVENTORY_BATCH_ADDED,
    EventType.INVENTORY_BATCH_DELETED,
    EventType.INVENTORY_BATCH_UPDATED,
    EventType.TX_BATCH_RELEASED,
    EventType.TX_RELEASE_BATCH_RECEIVED,
    EventType.TX_BATCH_UPGRADED,
    EventType.TX_BATCH_UPGRADE_REQUESTED,
    EventType.TX_UPGRADE_BATCH_RECEIVED,
    EventType.TX_UPGRADE_REQUEST_BATCH_RECEIVED,
    EventType.REJECT_BATCH_CREATED,
    EventType.REJECT_BATCH_RECEIVED,
    EventType.TX_MODIFY_BATCH_RECEIVED,
    EventType.TX_CANCEL_BATCH_RECEIVED,
    EventType.UNSOLICITED_OFFER_BATCH_MATCHED,
    EventType.RECALL_BATCH_CREATED,
    EventType.RECALL_BATCH_RECEIVED,
    EventType.RECALL_BATCH_DISPUTED,
    EventType.RECALL_BATCH_DISPUTED_RECEIVED,
    EventType.RECALL_BATCH_CANCELED,
    EventType.RECALL_BATCH_CANCELED_RECEIVED,
    EventType.CLIENT_POOL_UPDATED,
];

export const flattenBatches = (list) =>
    list
        .filter((e) => batch_types.includes(e.type))
        .map((e) => ({
            ...e,
            txEntries: e.payload.txEntries || e.payload,
        }));
export const removeBatches = (list) =>
    list.filter((e) => !batch_types.includes(e.type));

export const eventTypeToAction = (eventType) => {
    switch (eventType) {
        //Batch create cases
        case EventType.PRELOAN_BATCH_CREATED:
            return WebSocketActions.TxCreated;
        case EventType.LOAN_REQUEST_BATCH_CREATED:
            return WebSocketActions.SetLoanRequestedState;
        case EventType.OFFER_BATCH_CREATED:
            return WebSocketActions.OfferCreated;
        case EventType.REJECT_BATCH_CREATED:
            return WebSocketActions.RejectSent;
        //Batch receive cases
        case EventType.PRELOAN_BATCH_RECEIVED:
            return WebSocketActions.PreLoanReceived;
        case EventType.OFFER_BATCH_RECEIVED:
            return WebSocketActions.OfferReceived;
        case EventType.LOAN_REQUEST_BATCH_RECEIVED:
            return WebSocketActions.LoanRequestReceived;
        case EventType.REJECT_BATCH_RECEIVED:
            return WebSocketActions.RejectReceived;
        case EventType.REJECT_BATCH_SENT:
            return WebSocketActions.RejectBatchSent;
        case EventType.PRE_LOAN_BATCH_UPDATED:
            return WebSocketActions.PreLoanUpdated;
        case EventType.UNSOLICITED_OFFER_BATCH_MATCHED:
            return WebSocketActions.UnsolicitedOfferMatched;
        case EventType.PRE_LOAN_BATCH_UPDATE_RECEIVED:
            return WebSocketActions.PreLoanUpdateReceived;
        case EventType.TX_UPGRADE_REQUEST_BATCH_RECEIVED:
            return WebSocketActions.TxUpgradeRequestBatchReceived;
        //Remaining per-Tx cases
        case EventType.PRE_LOAN_EXPIRED:
            return WebSocketActions.PreLoanExpired;
        case EventType.OFFER_EXPIRED:
            return WebSocketActions.OfferExpired;
        case EventType.TX_BATCH_CONFIRMED:
            return WebSocketActions.TxBatchConfirmed;
        case EventType.TX_UNCONFIRMED:
            return WebSocketActions.TxUnConfirmed;
        case EventType.TX_FORK_BATCH_CREATED:
            return WebSocketActions.ForkCreated;
        case EventType.TX_FORK_BATCH_RECEIVED:
            return WebSocketActions.ForkReceived;
        case EventType.TX_BATCH_RELEASED:
            return WebSocketActions.TxBatchReleased;
        case EventType.TX_RELEASE_BATCH_RECEIVED:
            return WebSocketActions.TxReleaseBatchReceived;
        case EventType.TX_BATCH_UPGRADE_REQUESTED:
            return WebSocketActions.TxBatchUpgradeRequested;
        case EventType.TX_BATCH_UPGRADED:
            return WebSocketActions.TxBatchUpgraded;
        case EventType.TX_UPGRADE_BATCH_RECEIVED:
            return WebSocketActions.TxUpgradeBatchReceived;
        case EventType.WITHDRAWAL_BATCH_SENT:
        case EventType.WITHDRAWAL_BATCH_RECEIVED:
            return WebSocketActions.OfferWithdrawn;
        //Error Cases
        case EventType.LOAN_REQUEST_SEND_FAILED:
        case EventType.OFFER_SEND_FAILED:
        case EventType.PRELOAN_SEND_FAILED:
        case EventType.REJECT_SEND_FAILED:
        case EventType.CONFIRM_SEND_FAILED:
            return WebSocketActions.SendFailed;
        case EventType.ERROR_OFFER_EXPIRED:
            return WebSocketActions.ErrorOfferExpired;
        case EventType.ERROR_TX_ILLEGAL_STATUS:
        case EventType.ERROR_TX_ILLEGAL_OFFER:
        case EventType.ERROR_TX_ILLEGAL_LOAN:
        case EventType.ERROR_TX_ILLEGAL_REJECT:
        case EventType.ERROR_TX_ILLEGAL_FORK:
        case EventType.ERROR_TX_ILLEGAL_RELEASE:
        case EventType.ERROR_TX_ILLEGAL_UPGRADE:
            return WebSocketActions.ErrorTxIllegalStatus;
        case EventType.TX_BATCH_MODIFIED:
            return WebSocketActions.ConfirmationModified;
        case EventType.TX_MODIFY_BATCH_RECEIVED:
            return WebSocketActions.ConfirmationBatchModified;
        case EventType.TX_BATCH_CANCELED:
            return WebSocketActions.ConfirmationCanceled;
        case EventType.TX_CANCEL_BATCH_RECEIVED:
            return WebSocketActions.ConfirmationBatchCanceled;
        case EventType.TX_CONFIRM_BATCH_RECEIVED:
            return WebSocketActions.ConfirmationReceived;
        case EventType.CONFIRM_PROJECTION_INSERTED:
            return WebSocketActions.ConfirmationBatchProjectedInsert;
        case EventType.CONFIRM_PROJECTION_UPDATED:
            return WebSocketActions.ConfirmationBatchProjectedUpdate;
        case EventType.FILES_STORED:
            return WebSocketActions.FilesStored;
        case EventType.INVENTORY_BATCH_ADDED:
            return WebSocketActions.InventoryBatchAdded;
        case EventType.INVENTORY_BATCH_DELETED:
            return WebSocketActions.InventoryBatchDeleted;
        case EventType.INVENTORY_BATCH_UPDATED:
            return WebSocketActions.InventoryBatchUpdated;
        case EventType.AVAILABILITY_BATCH_RECEIVED:
            return WebSocketActions.AvailabilityBatchReceived;
        case EventType.AVAILABILITY_BATCH_DELETED:
            return WebSocketActions.AvailabilityBatchDeleted;
        case EventType.CPTY_SETTINGS_UPDATED:
        case EventType.CPTY_BORROWER_LIST_SETTINGS_UPDATED:
            return WebSocketActions.CptySettingsUpdated;

        // Recall events
        case EventType.RECALL_BATCH_CREATED:
        case EventType.RECALL_BATCH_DISPUTED:
        case EventType.RECALL_BATCH_CANCELED:
            return WebSocketActions.RecallActionCompleted;
        case EventType.RECALL_BATCH_RECEIVED:
            return WebSocketActions.RecallReceived;
        case EventType.RECALL_BATCH_DISPUTED_RECEIVED:
            return WebSocketActions.RecallDisputedReceived;
        case EventType.RECALL_BATCH_CANCELED_RECEIVED:
            return WebSocketActions.RecallCanceledReceived;

        // Client pool events
        case EventType.CLIENT_POOL_UPDATED:
            return WebSocketActions.ClientPoolUpdated;

        // Trade activity (dashboard refresh for trader/auditor)
        case EventType.TRADE_ACTIVITY_UPDATED:
            return WebSocketActions.TradeActivityUpdated;

        // Informational events (no UI action needed)
        case EventType.CONFIRM_SENT:
        case EventType.CONFIRMATION_CREATED:
        case EventType.CONFIRMATION_MODIFIED:
        case EventType.CONFIRMATION_RECEIVED:
        case EventType.FILES_STORED:
            return () => ({ type: "NOOP" });

        //Unknown error
        case EventType.UNKNOWN_ERROR:
            return WebSocketActions.UnknownError;
        default:
            return (event) => {
                console.warn("Unhandled WebSocket event type:", event.type);
                return { type: "NOOP" };
            };
    }
};
